import { getReadHostItemIndex, lazyLaunchTranslateCommand } from 'owa-addins-core';
import { TableView } from 'owa-mail-list-store';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import getLatestNonDraftItemIdFromConversation from 'owa-mail-message-actions/lib/utils/getLatestNonDraftItemIdFromConversation';
import { ActionSource } from 'owa-mail-store';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';

/**
 * Translate the given row
 * @param rowKeys the row keys
 * @param tableView the table view
 * @param actionSource the action source that triggers the block action
 */
export default action('translateFromTable')(async function translateFromTable(
    rowKeys: string[],
    tableView: TableView,
    actionSource: ActionSource
) {
    const selectedRowId = MailRowDataPropertyGetter.getRowClientItemId(rowKeys[0], tableView);
    if (!rowKeys || rowKeys.length == 0) {
        trace.error('Translate button should not show when empty list');
        return;
    }

    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            const latestNonDraftItemId = await getLatestNonDraftItemIdFromConversation(
                selectedRowId
            );
            if (latestNonDraftItemId && latestNonDraftItemId.Id) {
                (await lazyLaunchTranslateCommand.import())(
                    getReadHostItemIndex(latestNonDraftItemId.Id)
                );
            }
            break;

        case ReactListViewType.Message:
            (await lazyLaunchTranslateCommand.import())(getReadHostItemIndex(selectedRowId.Id));
            break;
    }
});
